import {RawInferenceResponse} from '../../types/gsp/RawInferenceResponse';
import {request} from '../request';

type TestExecuteUIParams = {
  files: File[];
  spaId?: string;
  targetDeviceType: string;
};

type DeploymentExecuteUIParams = {
  files: File[];
  spaId?: string;
};

export async function testExecute({spaId, files, targetDeviceType}: TestExecuteUIParams) {
  if (!spaId) {
    return undefined;
  }
  const data = new FormData();
  files.forEach(file => data.append('file', file));
  data.append('spaId', spaId);
  data.append('targetDeviceType', targetDeviceType);
  data.append('outputFormat', 'JSON');

  return await request<RawInferenceResponse>({
    method: 'POST',
    url: '/gsp/ui/execute',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
}
export async function deploymentExecute({spaId, files}: DeploymentExecuteUIParams) {
  if (!spaId) {
    return undefined;
  }
  const data = new FormData();
  files.forEach(file => data.append('file', file, file?.name));
  data.append('spaId', spaId);
  data.append('outputFormat', 'JSON');

  return await request<RawInferenceResponse>({
    method: 'POST',
    url: '/deployment/ui/execute',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
}
